
function waitForElement(selector, callback, maxWaitTime = 10000) {
    const interval = setInterval(() => {
        //console.log("Waiting for element...");
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval); 
            clearTimeout(timeout); 
            callback(element); 
        }
    }, 50);

    const timeout = setTimeout(() => {
        //console.log("Element not found within the maximum wait time.");
        clearInterval(interval); 
    }, maxWaitTime);
}

waitForElement('.wis2-promocode__link', (targetElement) => {
    if (targetElement.textContent.includes("alennuskoodi")) {
        targetElement.textContent = "Lisää tarjouskoodi »";
    }
});